import React from 'react'
import {
  ListGroup
} from 'react-bootstrap'

const List = ({ children, ...props }) =>
  <ListGroup {...props}>
    {children}
  </ListGroup>

export default List

